<template>
  <div>
    <header id="header-out">
      <h1><span>Waple</span></h1>
    </header>

    <section id="wrap">
      <div class="customer-input">
        <h3>고객 등록</h3>
        <em class="req">필수입력 항목 입니다.</em>

        <div class="wrap">
          <h4 class="req">고객 정보</h4>
          <dl>
            <dt>이름</dt>
            <dd>
              <input type="text" 
                ref="custName"
                :readonly="auth.isAuth"
                v-model="cust.name"
                placeholder="이름을 입력해주세요." />
            </dd>
            <dt>휴대폰 번호</dt>
            <dd>
              <input type="tel" 
                ref="custPhoneNum"
                :readonly="auth.isAuth"
                v-model="cust.phoneNum"
                placeholder='"-" 제외하고 입력해주세요.' />
            </dd>
          </dl>
        </div>

        <div class="wrap">
          <h4 class="req">약관</h4>
          <ul class="terms">
            <li>
              <p>[필수] 모바일 개인정보 수집 및 이용동의</p>
              <button type="button" @click="showTerms(true)">보기</button>
              <span class="checkbox circle">
                <input
                  type="checkbox"
                  name="cert-1"
                  id="cert-1"
                  v-model="terms.mobile"
                />
                <label for="cert-1"></label>
              </span>
            </li>
            <li>
              <p>[선택] 마케팅 목적 활용 동의</p>
              <button type="button" @click="showTerms(true)">보기</button>
              <span class="checkbox circle">
                <input
                  type="checkbox"
                  name="cert-2"
                  id="cert-2"
                  v-model="terms.marketing"
                />
                <label for="cert-2"></label>
              </span>
            </li>
          </ul>
          <button type="button" @click="agreeAllTerms">전체동의</button>
        </div>

        <div class="wrap">
          <h4 class="req">인증하기</h4>
          <div class="cert">
            <input type="tel" name="" id="" 
                ref="athnNo"
                :readonly="auth.isAuth"
                v-model="auth.authNo"
                placeholder="인증번호를 입력" />
            <em>{{auth.disCountDown}}</em>
            <button type="button" 
                v-bind:class="{fin:auth.isIssueAuthNoFin}"
                @click="issueAuthNo">{{btnAuthIssue}}</button>
            <button type="button" 
                v-bind:class="{fin:auth.isChkAuthFin}"
                @click="chkAuthNo">{{btnChkAuthNo}}</button>
          </div>
        </div>

        <div class="wrap">
          <h4>자녀 정보 <span>최대 5명까지 등록 가능</span></h4>
          <component
            v-for="child in childs"
            v-bind:is="child.type"
            :key="child.id"
            ref="child"
          ></component>
          <button
            v-if="this.childs.length < 5"
            type="button"
            class="child-add"
            @click="onAddChild"
          >
            자녀추가하기
          </button>
        </div>

        <div class="wrap">
          <h4>문의사항</h4>
          <textarea
            v-model="cust.memo"
            placeholder="문의할 내용을 입력해주세요."
          ></textarea>
        </div>
      </div>
    </section>
    <div class="btnWrap">
      <button type="button" class="white" @click="onCancel">취소</button>
      <button type="button" class="red" @click="onSave">전송</button>
    </div>

    <terms-cstmr-reg-by-cstmr
      :popTermsCstmrRegByCstmr.sync="popTermsCstmrRegByCstmr"
      @self-show="showTerms"
    ></terms-cstmr-reg-by-cstmr>
  </div>
</template>

<script>
import DynamicChildReg from "@/components/mycstmr/DynamicChildReg.vue";
import TermsCstmrRegByCstmr from "@/components/mycstmr/TermsCstmrRegByCstmr.vue";

export default {
  components: {
    DynamicChildReg,
    TermsCstmrRegByCstmr,
  },
  watch: {
    "$route.hash"(newHash, oldHash) {
      if (newHash === "#pop-erms-cstmr-reg-by-cstmr") {
        this.popTermsCstmrRegByCstmr = true;
      } else if (oldHash === "#pop-erms-cstmr-reg-by-cstmr") {
        this.popTermsCstmrRegByCstmr = false;
      }
    },
  },
  data() {
    return {
      popTermsCstmrRegByCstmr: false,
      childs: [],
      childsCount: 0,
      btnAuthIssue: '인증번호 발급',
      btnChkAuthNo: '인증하기',
      cust: {
          name: '',
          phoneNum: '',
          memo: ''
      },
      auth: {
          isAuth: false,
          authNo: '',
          countDown: 300,
          disCountDown: '5:00',
          countDwonTimer: null,
          isChkAuthFin: true,
          isIssueAuthNoFin: false
      },
      terms: {
        mobile: false,
        marketing: false,
      },
      params: {
        encSqno: "",
        encName: "",
        encPhoneNum: "",
        encAkdcde: "",
      },
      meta: {
          sqno: 0,
          name: '',
          phoneNum: '',
          akdcde: '',
      }
    };
  },
  methods: {
    onAddChild() {
      if (this.childs.length == 5) {
        alert("최대  5명까지 등록가능합니다.");
        return;
      }

      this.childs.push({
        type: "dynamic-child-reg",
        id: this.childsCount++,
      });
    },
    onRemoveChildReg(id) {
      console.log("CstmrRegCstmr.vue <onRemoveChildReg.id>", id);
      var index = this.childs.findIndex((f) => f.id === id);
      this.childs.splice(index, 1);
    },
    agreeAllTerms() {
      this.terms.mobile = true;
      this.terms.marketing = true;
    },
    showTerms(open) {
      if (open) {
        // this.detail.id = item.id;
        // this.detail.title = item.title;
        // this.hideScroll();
        this.$router.push("#pop-erms-cstmr-reg-by-cstmr");
        this.popTermsCstmrRegByCstmr = true;
      } else {
        // this.showScroll();
        this.popTermsCstmrRegByCstmr = false;
        this.$router.back(); // 😎 back button click
      }
    },
    hideScroll() {
      let elHtml = document.getElementsByTagName("html")[0];
      elHtml.style.overflowY = "hidden";
    },
    showScroll() {
      let elHtml = document.getElementsByTagName("html")[0];
      elHtml.style.overflowY = "auto";
    },
    chkCustInfo() {
        if(this.cust.name == '') {
            alert("고객 정보를 입력해주세요.");
            this.$refs.custName.focus();
            return false;
        }
        if(this.cust.phoneNum == '') {
            alert("고객 정보를 입력해주세요.");
            this.$refs.custPhoneNum.focus();
            return false;
        }
        if(this.meta.name != this.cust.name) {
            alert("등록요청정보와 상이합니다. 고객 정보를 확인해주세요.");
            this.$refs.custName.focus();
            return false;
        }
        if(this.meta.phoneNum != this.cust.phoneNum) {
            alert("등록요청정보와 상이합니다. 고객 정보를 확인해주세요.");
            this.$refs.phoneNum.focus();
            return false;
        }
        return true;
    },
    displayCountDown() {
        var min = parseInt((this.auth.countDown%3600)/60);
        var sec = this.auth.countDown%60;
        this.auth.disCountDown = min + ":" + this.zeroPad(sec, 2);
    },
    zeroPad(num, places) {
      var zero = places - num.toString().length + 1;
      return Array(+(zero > 0 && zero)).join("0") + num;
    },
    countDownTimer() {
      if(this.auth.countDown > 0) {
        this.auth.countDwonTimer = setTimeout(()=> {
          this.auth.countDown -= 1;
          this.displayCountDown();
          this.countDownTimer();
        }, 1000)
      } else {
          this.auth.isChkAuthFin = true;
          this.btnAuthIssue = "인증번호 발급";
      }
    },
    issueAuthNo() {
      if(this.auth.isIssueAuthNoFin) {
          return true;
      }

      if(!this.chkCustInfo()) {
          return;
      }

      if(!this.terms.mobile) {
        alert("약관 선택 후 진행해주세요.");
        return;
      }

      var that = this;
      this.$api.myCstmr
        .issueAuthNo(this.params)
        .then(function (data) {
            clearTimeout(that.auth.countDwonTimer);
            that.auth.isChkAuthFin = false;
            that.auth.countDown = 300;
            that.countDownTimer();
            if(process.env.NODE_ENV != 'production') {
                that.auth.authNo = data.athnNo;
            }
            that.btnAuthIssue = "인증번호 재발급";
        })
        .catch(function (error) {
            alert(error.rtMsg);
        });
    },
    chkAuthNo() {
      if(this.auth.isChkAuthFin) {
          return;
      }

      if(this.auth.authNo == '') {
        alert("인증번호를 입력 후 진행해주세요.");
        this.$refs.athnNo.focus();
        return false;
      }

    //   var that = this;
      var validAuthNoParams = {};
      validAuthNoParams.encSqno = this.params.encSqno;
      validAuthNoParams.athnNo = this.auth.authNo;

      var that = this;
      this.$api.myCstmr
        .validAuthNo(validAuthNoParams)
        .then(function () {
            clearTimeout(that.auth.countDwonTimer);
            that.auth.isChkAuthFin = true;
            that.auth.isIssueAuthNoFin = true;
            that.btnChkAuthNo = '인증완료';
            that.auth.isAuth = true;
        })
        .catch(function (error) {
            alert(error.rtMsg);
        });
    },
    onCancel() {
        location.reload();
    },
    getChildData() {
      var items = [];
      var childs = this.$refs.child;
      if(childs == undefined) {
          return {rt:'0000', items:items};
      }

      for(var child of childs) {
        var data = child.$data.child;
        if(data.name != '' 
            && data.sex != ''
            && data.birthday != '') {
          if(data.birthday.length != 8) {
            return {rt:'0001', items:items};  
          }
          var d = this.getDate(data.birthday);
          if( !this.isValidDate( d ) ) {
            return {rt:'0001', items:items};  
          }

          items.push({'name':data.name, 'sex':data.sex, 'birthday':data.birthday});
        } else {
          return {rt:'0001', items:items};
        }
      }
      return {rt:'0000', items:items};
    },
    getDate(str)  {
      return new Date( str.substring(0, 4) + "/" + str.substring(4, 6) + "/" + str.substring(6, 8) );
    },
    isValidDate(d) {
      return d instanceof Date && !isNaN(d);
    },
    onSave() {
      if(!this.chkCustInfo()) {
          return;
      }
    
      if(!this.terms.mobile) {
        alert("약관 선택 후 진행해주세요.");
        return;
      }
      
      var childsData = this.getChildData();
      if(childsData.rt != '0000') {
          alert("자녀정보를 입력해주세요.");
          return;
      }

      if(!this.auth.isAuth) {
        alert("인증 후 진행해주세요.");
        return;
      }
      
      var childs = childsData.items;
      var saveParams = {};
      saveParams.name = this.cust.name;
      saveParams.phoneNum = this.cust.phoneNum;
      saveParams.memo = this.cust.memo;
      saveParams.sqno = this.meta.sqno;
      saveParams.akdcde = this.meta.akdcde;
      saveParams.marketing = this.terms.marketing?'Y':'N';
      saveParams.childs = childs;

      var sendParms = {};
      sendParms.jsonString = JSON.stringify(saveParams);
      this.$api.myCstmr
        .saveCustInfo(sendParms)
        .then(function () {
            location.reload();
        })
        .catch(function (error) {
            alert(error.rtMsg);
        });


    }
  },
  created: function () {
    console.log(this.$options.name, "테스트", this.$route.query);
    var encSqno = this.$route.query.encSqno;
    var encName = this.$route.query.encName;
    var encPhoneNum = this.$route.query.encPhoneNum;
    var encAkdcde = this.$route.query.encAkdcde;
    if (encSqno == "" || encSqno === undefined) {
      this.$router
        .push({ name: "cstmr-reg-by-cstmr-expired" })
        .catch(function () {});
      return;
    }
    if (encName == "" || encName === undefined) {
      this.$router
        .push({ name: "cstmr-reg-by-cstmr-expired" })
        .catch(function () {});
      return;
    }
    if (encPhoneNum == "" || encPhoneNum === undefined) {
      this.$router
        .push({ name: "cstmr-reg-by-cstmr-expired" })
        .catch(function () {});
      return;
    }
    if (encAkdcde == "" || encAkdcde === undefined) {
      this.$router
        .push({ name: "cstmr-reg-by-cstmr-expired" })
        .catch(function () {});
      return;
    }

    this.params.encSqno = encSqno;
    this.params.encName = encName;
    this.params.encPhoneNum = encPhoneNum;
    this.params.encAkdcde = encAkdcde;
    var that = this;
    this.$api.myCstmr
      .chkCustAuthInfo(this.params)
      .then(function (data) {
        var expiredYn = data.expiredYn;
        var athnStat = data.athnStat;
        var custDuplicateCnt = data.custDuplicateCnt;

        if (expiredYn == "Y") {
          that.$router.push({ name: "cstmr-reg-by-cstmr-expired" }).catch(function () {});
        }
        if(athnStat == '2') {
          that.$router.push({ name: "cstmr-reg-by-cstmr-complete" }).catch(function () {});
        }
        if(custDuplicateCnt > 0) {
          that.$router.push({ name: "cstmr-reg-by-cstmr-complete" }).catch(function () {});
        }

        that.meta.sqno = data.sqno;
        that.meta.name = data.name;
        that.meta.phoneNum = data.phoneNum;
        that.meta.akdcde = data.akdcde;

        that.onAddChild();
      })
      .catch(function (error) {
        alert(error.rtMsg);
      });

    // this.onAddChild();
  },
  mounted() {
    this.$on("onRemoveChildReg", this.onRemoveChildReg);
  },
};
</script>